/* This file has all the menu items */
export const navItems: any[] = [];
